import { UserInitialStateType } from "DataTypes/Redux";
import { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Outlet, useParams } from "react-router-dom";
import { addOrg, clearOrg } from "Redux/Header/Action";
import { ConvertStringToNum } from "Utils/common";

const PreApprovedPlanLayout: FC = () => {
  const { orgId } = useParams();
  const newOrgId = ConvertStringToNum(orgId);
  const dispatch = useDispatch();
  const { myInfo }: UserInitialStateType = useSelector(
    (state: any) => state?.user
  );

  useEffect(() => {
    if (newOrgId == myInfo.practiceId) {
      dispatch(
        addOrg({
          id: myInfo.practiceId || null,
          name: myInfo.practiceName,
          masterPractice: myInfo.isMasterPractice,
          modelId: myInfo.practiceModelId,
          modelName: myInfo.practiceModelName,
        })
      );
    }
    return () => {
      dispatch(clearOrg());
    };
  }, []);
  return <Outlet />;
};

export default PreApprovedPlanLayout;
